export default __webpack_public_path__ + "static/media/first.5bb95291.jpg";